/* eslint-disable import/prefer-default-export */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { revokeDeveloperApiToken } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useRevokeDeveloperApiToken() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => revokeDeveloperApiToken(id),
    onSuccess: () => {
      queryClient.invalidateQueries(userQueryKeys.developerApiTokens({}).slice(0, 1));
    },
  });
}
